/* eslint-disable no-console,no-unused-vars */
import React, { Component } from 'react';
import { ThemeProvider, defaultTheme, LoadingScreen, Dialog} from '@nike/ruxac';
import Filters from './Components/Filters';
import Header from './Components/Header';
import TableGridContainer from './Components/TableGridContainer';
import ErrorMessage from './Components/ErrorMessage';
import Sticky from 'react-stickynode';
import {connect} from 'react-redux';
import {setLoadingIndicator} from './Actions/loading';
import {checkForToken, login} from './APIs/loginHelper';
import {setUserNameAction} from './Actions/userInfo';
import {authorizeUser} from './APIs/loginHelper';
import {setErrorState} from './Actions/errorHandler';
import {downloadAllPDF, downloadExcel, downloadSelectPDF} from './APIs/dataHelper';
import 'core-js/es6/number';
import 'core-js/es6/array';
class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAuthorized   : false,
            authError      : false,
            isCheckingAuth : true
        };
        this.downloadFile         = this.downloadFile.bind(this);
    }

    downloadFile(filename, fileExtension, token){
        if(filename && fileExtension === 'zip' ){
            this.setState({isCheckingAuth : false});
            return downloadAllPDF(token);
        }
        else if(filename && fileExtension === 'pdf'){
            this.setState({isCheckingAuth : false});
            return downloadSelectPDF(token);
        }
        else if(filename && fileExtension === 'xls'){
            this.setState({isCheckingAuth : false});
            return downloadExcel(token);
        }
    }
    async componentDidMount() {

        const jwt = checkForToken ();
        const filename = location.search.split('fileName=')[1];
        if(filename !== undefined)
            localStorage.setItem ('filename', filename);
        if (!jwt || !jwt.accessToken) {
            //redirect to SSO if detects query string has been entered and no jwt present
            login ();
        }
        else {
            let filename = localStorage.getItem ('filename');
            if(filename){
                let fileExtension = filename.split('.');
                fileExtension = fileExtension[fileExtension.length -1];
                this.downloadFile(filename, fileExtension, jwt.accessToken);
            }
            else{
                const authRes = await authorizeUser(jwt.accessToken)
                    .catch((err) => err.response.status);
                if(authRes === 200) {
                    this.setState({isAuthorized : true});
                }
                else {
                    this.setState({authError : true});
                }
                if(authRes) {
                    this.setState({isCheckingAuth : false});
                }
                if(this.state.isAuthorized) {
                    this.props.setUserNameAction(jwt.username);
                }
            }
        }
    }

    render() {
        const filename = location.search.split('fileName=')[1];
        return (
            <ThemeProvider theme={defaultTheme}>
                <div className="container-app">
                    {!filename && (
                        <Sticky
                            enabled={true}
                            top={0}
                            innerZ={1000}
                        >
                            <Header />
                        </Sticky>
                    )}
                    {!filename  && (
                        <LoadingScreen
                            isLoading={this.state.isCheckingAuth}
                            loadingMessage='Loading Application'
                        />
                    )}
                    {filename && (
                        <ErrorMessage
                            message={"File is Downloading"}
                        />
                    )}
                    {!filename && this.state.isAuthorized && (
                        <div>
                            <Filters/>
                            <div className={`grid-container`}>
                                <div className={`shadowBox tableGrid-container-sc`}>
                                    <TableGridContainer
                                        data={this.props.data.payload}
                                        pageSize={this.props.data.pageSize}
                                        pageIndex={this.props.data.pageIndex}
                                        offset={this.props.data.offset}
                                        rowCount={this.props.data.rowCount}
                                        isNewSearched={this.props.data.isNewSearched}
                                        title='Material Lab Test Form Results'
                                        name='srcChange'
                                        dataCached={this.props.data.dataCached}
                                    />
                                </div>
                            </div>
                        </div>)}

                    {!filename && !this.state.isCheckingAuth && this.state.authError && (
                        <ErrorMessage
                            message={"You are not an authorized user of this application. Please contact Frontline Support to request access."}
                        />
                    )}

                    <Dialog
                        className={`dialog-confirm`}
                        content={this.props.error.message}
                        onConfirm={() => {
                            this.props.setErrorState(undefined, "");
                        }}
                        onOverlayClick={() => {
                            this.props.setErrorState(undefined, "");
                        }}
                        open={this.props.error.code !== undefined}
                        title="Error"
                    />

                </div>
            </ThemeProvider>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        data             : state.data,
        loadingIndicator : state.loadingIndicator,
        error            : state.errorHandler,
        login            : state.loginHandler
    };
};

const mapDispatchProps = {
    setLoadingIndicator,
    setUserNameAction,
    setErrorState,
    downloadAllPDF
};

export default connect(mapStateToProps, mapDispatchProps)(App);



// WEBPACK FOOTER //
// ./src/App.js